import { useCallback, useRef } from "react"

/**
 * 接收一个数组，返回一个方法，每次调用返回指定数量的元素
 * @param {Array} array 输入的数组
 * @param {number} [size=1] 每次返回的元素数量，默认为1
 * @returns {Function} 获取元素的函数
 */
export function useArraySlicer(array, size = 1) {
    // 使用 useRef 保持索引状态，避免每次渲染重置
    const indexRef = useRef(6)

    // 使用 useCallback 缓存函数
    const getNextItems = useCallback(() => {
        // 如果输入不是数组或大小无效，返回空数组
        if (!Array.isArray(array) || size <= 0) {
            return []
        }

        // 计算当前批次的开始和结束索引
        const start = indexRef.current
        const end = start + size

        // 获取当前批次的元素
        const items = array.slice(start, end)

        // 更新索引
        indexRef.current = end >= array.length ? 0 : end

        return items
    }, [array, size])
    return getNextItems
}
